import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

const ProgressContext = createContext({});

export function ProgressProvider({ children }) {
  const { currentUser } = useAuth();
  const key = currentUser ? `sl_progress_${currentUser.email}` : null;

  const [completed, setCompleted] = useState(() => {
    if (!key) return {};
    try {
      return JSON.parse(localStorage.getItem(key) || "{}");
    } catch {
      return {};
    }
  });

  useEffect(() => {
    if (!key) return;
    try {
      setCompleted(JSON.parse(localStorage.getItem(key) || "{}"));
    } catch {
      setCompleted({});
    }
  }, [key]);

  const markComplete = (lessonId) => {
    if (!key) return;
    const next = { ...completed, [lessonId]: true };
    setCompleted(next);
    localStorage.setItem(key, JSON.stringify(next));
  };

  const isComplete = (lessonId) => !!completed[lessonId];
  const totalComplete = Object.keys(completed).length;

  return (
    <ProgressContext.Provider
      value={{ completed, markComplete, isComplete, totalComplete }}
    >
      {children}
    </ProgressContext.Provider>
  );
}

export const useProgress = () => useContext(ProgressContext);
